import { FAQ_ITEMS } from './faqContent.mjs';

export const FAQ_SCHEMA_ID = 'faq-schema';
export const FAQ_SCHEMA_PATHS = new Set(['/', '/home-page', '/pricing']);
export const FAQ_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQ_ITEMS.map(({ question, answer }) => ({
    '@type': 'Question',
    name: question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: answer,
    },
  })),
};

export const syncFaqSchema = (pathname, documentRef = document) => {
  const existing = documentRef.getElementById(FAQ_SCHEMA_ID);
  const shouldExist = FAQ_SCHEMA_PATHS.has(pathname);

  if (!shouldExist) {
    existing?.remove();
    return;
  }

  if (existing) return;

  const script = documentRef.createElement('script');
  script.id = FAQ_SCHEMA_ID;
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(FAQ_SCHEMA);
  documentRef.head.appendChild(script);
};
